import React from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

export default function StoreProjectNameModal({
  isOpen,
  toggle,
  title = "Project Name",
  label = "Project Name",
  placeholder = "e.g. 2BHK - Koramangala",
  value,
  onChange,
  onSubmit,
  busy = false,
  error = null,
  submitLabel = "Continue",
}) {
  const handleSubmit = (e) => {
    e?.preventDefault?.();
    onSubmit?.();
  };

  return (
    <Modal isOpen={isOpen} toggle={busy ? undefined : toggle} centered>
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={busy ? undefined : toggle}>{title}</ModalHeader>
        <ModalBody>
          {error ? (
            <div className="alert alert-danger py-2 px-3 mb-3" role="alert">
              {error}
            </div>
          ) : null}
          <Label for="store-project-name-input" className="fw-semibold mb-2">
            {label}
          </Label>
          <Input
            id="store-project-name-input"
            type="text"
            className="unmask"
            value={value}
            placeholder={placeholder}
            autoFocus
            disabled={busy}
            onChange={(e) => onChange?.(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSubmit?.();
              }
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="link"
            className="text-muted text-decoration-none"
            type="button"
            disabled={busy}
            onClick={toggle}
          >
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={busy}>
            {busy ? "Saving..." : submitLabel}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
